<template src="../templates/MultipleSortBooking.html"></template>

<script>
import draggable from "vuedraggable";
export default {
  name: "MultipleSortBooking",
  props: ["searchModel"],
  components: { draggable },
  watch: {
    list1: {
      handler: function(newVal, oldVal) {
        console.log("Child Updated with new List ===>", newVal);
        this.list1 = newVal;
        this.$emit("sort-list", this.list1);
      },
      deep: true
    }
  },
  methods: {
    handleDrop(toList, data) {
      const fromList = data.list;
      if (fromList) {
        toList.push(data.item);
        fromList.splice(fromList.indexOf(data.item), 1);
        toList.sort((a, b) => a > b);
      }
    },
    loadInterpreters: function(filterByState = true) {
      if (this.searchModel.language != null && this.language !== "") {
        let url =
          this.$localApiURL +
          "interpreters/get/" +
          this.searchModel.language +
          "/" +
          filterByState.toString();
        let localThis = this;
        this.$http
          .get(url, {
            headers: { Bearer: localStorage.getItem("jwt") }
          })
          .then(function(response) {
            //
            localThis.interpreters = response.data;
            localThis.interpretersTemp = response.data;
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    loadLanguages: function() {
      let url = this.$localApiURL + "languages/get";
      let localThis = this;
      this.$http
        .get(url, {
          headers: { Bearer: localStorage.getItem("jwt") }
        })
        .then(function(response) {
          localThis.languages = response.data;
          localThis.languagesTemp = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    filterLanguages(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.languages = this.languagesTemp.filter(item => {
            if (item != null && item.language != null) {
              return (
                item.language.toLowerCase().indexOf(query.toLowerCase()) > -1
              );
            }
            return false;
          });
        }, 200);
      } else {
        this.languages = [];
      }
    },
    filterInterpreters(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.interpreters = this.interpretersTemp.filter(item => {
            if (item != null && item.interpreterName != null) {
              return (
                item.interpreterName
                  .toLowerCase()
                  .indexOf(query.toLowerCase()) > -1
              );
            }
            return false;
          });
        }, 200);
      } else {
        this.interpreters = [];
      }
    },

    /**
     * SORTING
     */
    add: function() {
      this.list.push({ name: "Juan" });
    },
    replace: function() {
      this.list = [{ name: "Edgard" }];
    },
    clone: function(el) {
      return {
        name: el.name + " cloned"
      };
      ``;
    },
    log: function(evt) {
      window.console.log(evt);
    },

    updown: function(id) {
      console.log("id updown ====> ", id);
      let neww = this.list1;
      for (let ctr = 0; ctr < neww.length; ctr++) {
        if (neww[ctr].id == id) {
          neww[ctr].sort = neww[ctr].sort == "desc" ? "asc" : "desc";
        }
      }
      this.list1 = neww;
    },

    addSort(id) {
      console.log("add sort", id);
      let newList = this.list1;
      for (let ctr = 0; ctr < this.list2.length; ctr++) {
        if (this.list2[ctr].id == id) {
          newList.push(this.list2[ctr]);
          this.list1 = newList;
        }
      }

      this.list2 = this.list2.filter(el => el.id !== id);
    },
    deleteSort(id) {
      console.log("delete sort", id);
      for (let ctr = 0; ctr < this.list1.length; ctr++) {
        if (this.list1[ctr].id == id) {
          console.log(this.list1[ctr]);
          this.list2.push(this.list1[ctr]);
        }
      }

      this.list1 = this.list1.filter(el => el.id !== id);
    },
    resetSort() {
      this.list1 = [];
      this.list2 = this.listOrig;
    }
  },
  created() {
    this.loadLanguages();
  },
  data() {
    return {
      listOrig: [
        {
          name: "Ref No",
          id: 1,
          sort: "desc",
          sortDir1: "Sort number in ascending order",
          sortDir2: "Sort number in descending order"
        },
        {
          name: "Location",
          id: 2,
          sort: "desc",
          sortDir1: "Sort from Z to A",
          sortDir2: "Sort from A to Z"
        },
        {
          name: "Language",
          id: 3,
          sort: "desc",
          sortDir1: "Sort from Z to A",
          sortDir2: "Sort from A to Z"
        },
        {
          name: "Interpreter",
          id: 4,
          sort: "desc",
          sortDir1: "Sort from Z to A",
          sortDir2: "Sort from A to Z"
        },
        {
          name: "Date",
          id: 5,
          sort: "desc",
          sortDir1: "Sort from oldest to newest",
          sortDir2: "Sort from newest to oldest"
        },
        {
          name: "Start",
          id: 6,
          sort: "desc",
          sortDir1: "Sort from oldest to newest",
          sortDir2: "Sort from newest to oldest"
        },
        {
          name: "Finish",
          id: 7,
          sort: "desc",
          sortDir1: "Sort from oldest to newest",
          sortDir2: "Sort from newest to oldest"
        },
        {
          name: "Requested By",
          id: 8,
          sort: "desc",
          sortDir1: "Sort from Z to A",
          sortDir2: "Sort from A to Z"
        }
      ],
      list1: [],
      list2: [
        {
          name: "Ref No",
          id: 1,
          sort: "desc",
          sortDir1: "Sort number in ascending order",
          sortDir2: "Sort number in descending order"
        },
        {
          name: "Location",
          id: 2,
          sort: "desc",
          sortDir1: "Sort from Z to A",
          sortDir2: "Sort from A to Z"
        },
        {
          name: "Language",
          id: 3,
          sort: "desc",
          sortDir1: "Sort from Z to A",
          sortDir2: "Sort from A to Z"
        },
        {
          name: "Interpreter",
          id: 4,
          sort: "desc",
          sortDir1: "Sort from Z to A",
          sortDir2: "Sort from A to Z"
        },
        {
          name: "Date",
          id: 5,
          sort: "desc",
          sortDir1: "Sort from oldest to newest",
          sortDir2: "Sort from newest to oldest"
        },
        {
          name: "Start",
          id: 6,
          sort: "desc",
          sortDir1: "Sort from oldest to newest",
          sortDir2: "Sort from newest to oldest"
        },
        {
          name: "Finish",
          id: 7,
          sort: "desc",
          sortDir1: "Sort from oldest to newest",
          sortDir2: "Sort from newest to oldest"
        },
        {
          name: "Requested By",
          id: 8,
          sort: "desc",
          sortDir1: "Sort from Z to A",
          sortDir2: "Sort from A to Z"
        }
      ],
      languages: [],
      languagesTemp: [],
      interpreters: [],
      interpretersTemp: [],
      loading: false
    };
  }
};
</script>
<style scoped>
.section {
  margin-top: 30px;
  margin-bottom: 50px;
}
.drag,
.drop {
  box-sizing: border-box;
  display: inline-block;
  border-radius: 10px;
  width: 100px;
  height: 100px;
  background: #ccc;
  vertical-align: middle;
  margin-right: 20px;
  position: relative;
  padding: 5px;
  padding-top: 35px;
  text-align: center;
  margin: 3px;
}
.drag {
  color: #fff;
  cursor: move;
  background: #777;
  border-right: 2px solid #666;
  border-bottom: 2px solid #666;
}
.drop {
  background: #eee;
  border-top: 2px solid #ccc;
  border-left: 2px solid #ddd;
}
.drag {
  display: inline-block;
}
.drag.A {
  background: #aaa;
}
.drag.B {
  background: #888;
}
.drag.C {
  background: #666;
}
.drag.D {
  background: #444;
}
.drag.E {
  background: #222;
}
.drag.F {
  background: #000;
}
.drop {
  display: inline-block;
  vertical-align: top;
  padding: 15px;
  margin-bottom: 20px;
  width: auto;
  height: auto;
}
.dragHere {
  height: 100%;
  background: #dedede;
  border-radius: 15px;
  border: 3px dotted #c5c3c3;
}
.dragHere::before {
  padding: 0px 7%;
  content: "Click on the arrow from the items in the left or drag and drop fields here";
  width: 88%;
  height: 100%;
  padding-top: 30%;
  position: absolute;
  margin: 0 auto;
}
.sortOrderInfo {
  font-size: 20px;
  color: #838383;
}
</style>


// WEBPACK FOOTER //
// src/components/MultipleSortBooking.vue